var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 20.5 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.578 10.725a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666M8.244 5.725a.333.333 0 1 1 .667 0V9.06a.333.333 0 1 1-.667 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.6 14.667a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333m.557-10.42a.667.667 0 0 0-1.116 0L4.05 10.36a.667.667 0 0 0 .558 1.03h7.985c.53 0 .847-.587.558-1.03z",
    clipRule: "evenodd"
  })));
};
export default SvgWarningIcon;